// src/admin/pages/AdminOrderDetails.js
import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useRef } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaSearch } from "react-icons/fa";
import {
  FaChevronDown,
  FaUserEdit,
  FaBoxOpen,
  FaBan,
  FaStickyNote,
  FaArchive,
} from "react-icons/fa";
import { FaShoppingCart, FaMousePointer, FaChartLine } from "react-icons/fa";
import {
  FaInbox,
  FaTruck,
  FaMoneyBill,
  FaUser,
  FaBox,
  FaPrint,
  FaEllipsisH,
  FaPen,
  FaGlobe,
  FaWhatsapp,
  FaStore,
  FaEye,
} from "react-icons/fa";
import { deleteAdminOrder } from "../../services/adminOrders.api";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminOrderById,
  updateAdminOrderStatus,
  updateAdminOrderCustomer,
} from "../../services/adminOrders.api";
import { buildOrderConfirmationWhatsAppMessage } from "../../utils/whatsappOrderMessages";
import { buildReviewRequestWhatsAppMessage } from "../../utils/whatsappOrderReviewMessages";
import {
  deleteAdminOrderItem,
  addAdminOrderItems,
} from "../../services/adminOrders.api";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import { getAdminProducts } from "../../services/adminProducts.api";
import { getAdminUsersActivity } from "../../services/adminUserActivity.api";
import { FiX, FiTruck, FiArchive, FiFileText } from "react-icons/fi";

function AdminOrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { lang } = useContext(AdminLanguageContext);

  const orderStatusRef = useRef(null);
  const itemsSectionRef = useRef(null);
  const customerSectionRef = useRef(null);

  const [editMenuOpen, setEditMenuOpen] = useState(false);
  const [editMode, setEditMode] = useState(null); 

  const [actionsMenuOpen, setActionsMenuOpen] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [customerOverlayOpen, setCustomerOverlayOpen] = useState(false);

  const [mobileHeaderMenuOpen, setMobileHeaderMenuOpen] = useState(false);
  const [mobileMoreActionsOpen, setMobileMoreActionsOpen] = useState(false);

  const [editingCustomer, setEditingCustomer] = useState(false);
  const [customerDraft, setCustomerDraft] = useState(null);
  const [showCustomerToast, setShowCustomerToast] = useState(false);

  const [itemToDelete, setItemToDelete] = useState(null);

  const [showAddItem, setShowAddItem] = useState(false);
  const [products, setProducts] = useState([]);
  const [activeProduct, setActiveProduct] = useState(null);
  const [activeVariant, setActiveVariant] = useState(null);
  const [variantQty, setVariantQty] = useState(1);

  const [conversionModalOpen, setConversionModalOpen] = useState(false);

  const [activityRows, setActivityRows] = useState([]);

const [statusMenuOpen, setStatusMenuOpen] = useState(false);

const [productSearch, setProductSearch] = useState("");

const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);

const [adminNoteOpen, setAdminNoteOpen] = useState(false);
const [draftAdminNote, setDraftAdminNote] = useState("");

const [originalOrder, setOriginalOrder] = useState(null);

const [saving, setSaving] = useState(false);

const [extraFeesModalOpen, setExtraFeesModalOpen] = useState(false);
const [draftExtraLabel, setDraftExtraLabel] = useState("");
const [draftExtraAmount, setDraftExtraAmount] = useState(0);

const [discountModalOpen, setDiscountModalOpen] = useState(false);
const [discountType, setDiscountType] = useState("percent");
const [draftDiscount, setDraftDiscount] = useState(0);
const [isDirty, setIsDirty] = useState(false);

  const TEXT = {
    EN: {
      backToOrders: "Back to Orders",
      order: "Order",
      placedOn: "Placed on",
      loading: "Loading order...",
      orderStatus: "Order Status",
      items: "Items",
      subtotal: "Subtotal",
      shipping: "Shipping",
      total: "Total",
      customerDetails: "Customer Details",
      name: "Name",
      phone: "Phone",
      email: "Email",
      city: "City",
      address: "Address",
      paymentMethod: "Payment Method",
      discount: "Discount",
      noDiscount: "No discount",
      addItemTitle: "Add Item to Order",
      searchPlaceholder: "Search by ID or name...",
      selectVariant: "Select Variant",
      back: "Back",
      quantity: "Quantity",
      cancel: "Cancel",
      add: "Add",
      stock: "Stock",
      removeItemTitle: "Remove Item",
      removeItemConfirm: "Are you sure you want to remove",
      edit: "Edit",
      print: "Print",
      moreActions: "More actions",
      placedDate: "Placed date",
      placedTime: "Placed time",
      sourceLabel: "Source",
      website: "Website",
      whatsapp: "WhatsApp",
      store: "Store",
      newSubtotal: "New Subtotal",
      governorate: "Governorate",
      note: "Note",
      save: "Save",
      shippingMethod: "Shipping Method",
      notes: "Notes",
      noNotes: "No notes",
      editDiscount: "Edit discount",
addDiscount: "Add discount",
      products: "Products",
      onlineStore: "Online Store",
      payment: "Payment",
      contactInformation: "Contact information",
      shippingAddress: "Shipping address",

      // ✅ NEW
      extraFees: "Extra Fees",
      guest: "Guest",
      extraFeesText: "Fee name",
      extraFeesAmount: "Amount ($)",
      noProducts: "No products added",
      orderSummary: "Order summary",

      status: {
        pending: "Pending",
        processing: "Processing",
        packed: "Packed",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
        paid: "Paid",
refunded: "Refunded",
      },
    },
    AR: {
      backToOrders: "العودة إلى الطلبات",
      order: "طلب",
      placedOn: "تاريخ الطلب",
      guest: "ضيف",
      onlineStore: "المتجر الإلكتروني",
      loading: "جاري تحميل الطلب...",
      orderStatus: "حالة الطلب",
      items: "المنتجات",
      subtotal: "المجموع الفرعي",
      shipping: "الشحن",
      editDiscount: "تعديل الخصم",
addDiscount: "إضافة خصم",
      total: "الإجمالي",
      customerDetails: "معلومات العميل",
      name: "الاسم",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      addItemTitle: "إضافة منتج إلى الطلب",
      searchPlaceholder: "بحث بالرقم أو الاسم...",
      selectVariant: "اختر النوع",
      back: "رجوع",
      quantity: "الكمية",
      cancel: "إلغاء",
      add: "إضافة",
      stock: "المخزون",
      removeItemTitle: "حذف المنتج",
      removeItemConfirm: "هل أنت متأكد من حذف",
      edit: "تعديل",
      print: "طباعة",
      moreActions: "المزيد",
      placedDate: "تاريخ الطلب",
      placedTime: "وقت الطلب",
      sourceLabel: "المصدر",
      website: "الموقع",
      whatsapp: "واتساب",
      store: "المتجر",
      city: "المدينة",
      address: "العنوان",
      paymentMethod: "طريقة الدفع",
      discount: "الخصم",
      noDiscount: "لا يوجد خصم",
      newSubtotal: "المجموع بعد الخصم",
      governorate: "المحافظة",
      note: "ملاحظة",
      save: "حفظ",
      shippingMethod: "طريقة الشحن",

      // ✅ NEW
      extraFees: "رسوم إضافية",
      extraFeesText: "اسم الرسوم",
      extraFeesAmount: "القيمة ($)",
      notes: "ملاحظات",
      noNotes: "لا توجد ملاحظات",
      products: "المنتجات",
      payment: "الدفع",
      contactInformation: "معلومات التواصل",
      shippingAddress: "عنوان الشحن",

      noProducts: "لا توجد منتجات مضافة",
      orderSummary: "ملخص الطلب",
      status: {
        pending: "قيد الانتظار",
        processing: "قيد المعالجة",
        packed: "تم التجهيز",
        shipped: "تم الشحن",
        delivered: "تم التسليم",
        cancelled: "ملغي",
        paid: "مدفوع",
refunded: "مسترجع",
      },
    },
  }[lang];

  const formatPrice = (value) => {
  const n = Number(value || 0);
  return `$${n.toFixed(2)}`;
};

const formatItemPriceLabel = (item) => {
  if (item.isBxgyFree || item.bxgyType === "free") {
    return lang === "AR" ? "مجاني" : "FREE";
  }

  return formatPrice(Number(item.price || 0));
};

  const hasOrderChanges = () => {
  if (!originalOrder || !order) return false;

  if (order.status !== originalOrder.status) return true;
if ((order.adminNote || "") !== (originalOrder.adminNote || "")) return true;
if ((order.extraFeeLabel || "") !== (originalOrder.extraFeeLabel || "")) return true;
if (Number(order.extraFeeAmount || 0) !== Number(originalOrder.extraFeeAmount || 0)) return true;
if (Number(order.discount || 0) !== Number(originalOrder.discount || 0)) return true;

  return false;
};

 const handleBackClick = () => {
  if (hasOrderChanges()) {
    setShowLeaveConfirm(true);
  } else {
    navigate("/admin/orders");
  }
};

  const saveAdminNote = () => {
  setOrder((prev) => ({
    ...prev,
    adminNote: draftAdminNote,
  }));
  setAdminNoteOpen(false);
};

   const startEditCustomer = () => {
  setCustomerDraft({
    name: order.customer.name || "",
    phone: order.customer.phone || "",
    email: order.customer.email || "",
    governorate: order.customer.governorate || "",
    area: order.customer.area || "",
    street: order.customer.street || "",
    building: order.customer.building || "",
  });
  setEditingCustomer(true);
};

const saveCustomerDetails = async () => {
  try {
    await updateAdminOrderCustomer(order.id, customerDraft);

    const fresh = await getAdminOrderById(order.id);
    setOrder((prev) => ({
      ...fresh,
      _originalStatus: prev._originalStatus,
    }));

    setEditingCustomer(false);
    setEditMode(null)
    setShowCustomerToast(true);
    setTimeout(() => setShowCustomerToast(false), 3000);
  } catch (e) {
    alert(e.message);
  }
};

useEffect(() => {
  if (!originalOrder || !order) return;

  const current = {
    status: order.status,
    adminNote: order.adminNote || "",
    extraFeeLabel: order.extraFeeLabel || "",
    extraFeeAmount: Number(order.extraFeeAmount || 0),
    discount: Number(order.discount || 0),
  };

  const original = {
    status: originalOrder.status,
    adminNote: originalOrder.adminNote || "",
    extraFeeLabel: originalOrder.extraFeeLabel || "",
    extraFeeAmount: Number(originalOrder.extraFeeAmount || 0),
    discount: Number(originalOrder.discount || 0),
  };

  const changed = Object.keys(original).some(
    (key) => original[key] !== current[key]
  );

  setIsDirty(changed);
}, [order, originalOrder]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".customer-overlay") &&
      !e.target.closest(".customer-trigger")
    ) {
      setCustomerOverlayOpen(false);
    }
  };

  if (customerOverlayOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [customerOverlayOpen]);

useEffect(() => {
  getAdminUsersActivity()
    .then(setActivityRows)
    .catch(console.error);
}, []);

useEffect(() => {

const close = (e)=>{
if(!e.target.closest(".actions-menu-trigger")){
setActionsMenuOpen(false)
}
}

document.addEventListener("click",close)

return ()=>document.removeEventListener("click",close)

},[])

useEffect(() => {

  const close = (e) => {
    if (!e.target.closest(".status-menu-trigger")) {
      setStatusMenuOpen(false);
    }
  };

  document.addEventListener("click", close);

  return () => document.removeEventListener("click", close);

}, []);

useEffect(() => {

const close = (e)=>{
if(!e.target.closest(".edit-menu-trigger")){
setEditMenuOpen(false)
}
}

document.addEventListener("click",close)

return ()=>document.removeEventListener("click",close)

},[])

useEffect(() => {
  const close = (e) => {
    if (
      !e.target.closest(".mobile-header-menu") &&
      !e.target.closest(".mobile-header-menu-trigger")
    ) {
      setMobileHeaderMenuOpen(false);
      setMobileMoreActionsOpen(false);
    }
  };

  document.addEventListener("mousedown", close);
  return () => document.removeEventListener("mousedown", close);
}, []);

useEffect(() => {
  getAdminProducts().then(setProducts);
}, []);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    getAdminOrderById(id)
      .then((data) => {
        if (mounted) {
          // ✅ ensure defaults exist (so inputs never break)
          const preparedOrder = {
            ...data,
            _originalStatus: data.status,
            extraFeeLabel: data?.extraFeeLabel || "",
            extraFeeAmount: Number(data?.extraFeeAmount || 0),
            adminNote: data?.adminNote || "",
          };

          setOrder(preparedOrder);
          setOriginalOrder(preparedOrder);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));

    return () => (mounted = false);
  }, [id]);

  const stopEditing = () => {
  setEditMode(null);
  setEditMenuOpen(false);
  setEditingCustomer(false);
  setCustomerDraft(null);
};

const scrollToOrderStatus = () => {
  if (orderStatusRef.current) {
    orderStatusRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  setTimeout(() => {
    setStatusMenuOpen(true);
  }, 300);
};

const scrollToOrderItemsEdit = () => {
  if (itemsSectionRef.current) {
    const y =
      itemsSectionRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      150; // mobile offset

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }

  setEditMode("items");
};

const handleSave = () => {
  setShowConfirm(true);
};

const scrollToCustomerEdit = () => {
  if (customerSectionRef.current) {
    customerSectionRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  startEditCustomer();
  setEditMode("customer");
};

  const updateOrderStatus = async () => {
  const nextStatus = order.status;
  const prevStatus = order._originalStatus;

  let waWindow = null;

  // ✅ Open window ONLY for the two valid transitions
  const shouldSendConfirmWA =
    prevStatus === "pending" && nextStatus === "shipped";

  const shouldSendReviewWA =
    prevStatus === "shipped" && nextStatus === "delivered";

  if (shouldSendConfirmWA || shouldSendReviewWA) {
    waWindow = window.open("", "_blank");
  }

 try {
  setSaving(true);

  await updateAdminOrderStatus(
    order.id,
    nextStatus,
    order.extraFeeLabel,
    order.extraFeeAmount,
    order.adminNote,
    order.discount,
    order.discountType,
    order.discountInput
  );

  const fresh = await getAdminOrderById(order.id);

  setOrder((prev) => ({
    ...fresh,
    _originalStatus: fresh.status,
    extraFeeLabel: fresh?.extraFeeLabel || "",
    extraFeeAmount: Number(fresh?.extraFeeAmount || 0),
    discount: Number(fresh?.discount || 0),
    discountType: prev.discountType,
    discountInput: prev.discountInput,
    adminNote: fresh?.adminNote || "",
  }));

  setOriginalOrder((prev) => ({
    ...fresh,
    _originalStatus: fresh.status,
    extraFeeLabel: fresh?.extraFeeLabel || "",
    extraFeeAmount: Number(fresh?.extraFeeAmount || 0),
    discount: Number(fresh?.discount || 0),
    discountType: prev?.discountType,
    discountInput: prev?.discountInput,
    adminNote: fresh?.adminNote || "",
  }));

    if (waWindow && fresh.customer?.phone) {
      let phone = fresh.customer.phone.replace(/\D/g, "");

      // ✅ Lebanon-safe fallback
      if (!phone.startsWith("961")) {
        phone = "961" + phone;
      }

      let msg = "";

      if (shouldSendConfirmWA) {
        msg = buildOrderConfirmationWhatsAppMessage(fresh);
      }

      if (shouldSendReviewWA) {
        msg = buildReviewRequestWhatsAppMessage(fresh);
      }

      if (msg) {
        waWindow.location.href = `https://wa.me/${phone}?text=${msg}`;
      } else {
        waWindow.close();
      }
    }

    setShowConfirm(false);
  setShowToast(true);

  setTimeout(() => {
    navigate("/admin/orders");
  }, 1000);

} catch (e) {
  if (waWindow) waWindow.close();
  alert(e.message);
} finally {
  setSaving(false);
}
};



  const formatDateTime = (d) => new Date(d).toLocaleString();

  const printOrder = (order) => {
    const w = window.open("", "_blank");

    const extraAmount = Number(order.extraFeeAmount || 0);
    const extraLabel = (order.extraFeeLabel || "").trim();

    w.document.write(`
      <html>
        <head>
          <title>Order ${order.orderNumber}</title>
          <style>
            body {
              font-family: Arial;
              padding: 20px;
              width: 148mm;
              margin: auto;
              text-align: center;
            }

            .section-title {
              border: 1px solid #000;
              padding: 6px;
              margin-top: 20px;
              font-weight: bold;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
              text-align: center;
            }

            th, td {
              border: 1px solid #000;
              padding: 6px;
              font-size: 12px;
            }

            .box {
              border: 1px solid #000;
              border-radius: 10px;
              height: 60px;
              margin-top: 20px;
            }
          </style>
        </head>

        <body>

          <h2>Order #${order.orderNumber}</h2>

          <p><b>Date:</b> ${formatDateTime(order.created_at)}</p>
          <p><b>Total Items:</b> ${order.items.length}</p>

          <div class="section-title">Customer Details</div>
          <p><b>Name:</b> ${order.customer.name}</p>
          <p><b>Phone:</b> ${order.customer.phone}</p>
          <p><b>Email:</b> ${order.customer.email || ""}</p>
          <p><b>Governorate:</b> ${order.customer.governorate}</p>
<p><b>Area:</b> ${order.customer.area}</p>
<p><b>Street:</b> ${order.customer.street}</p>
<p><b>Building:</b> ${order.customer.building}</p>


          <div class="section-title">Products</div>
          <table>
            <tr>
              <th>Product ID</th>
              <th>Qty</th>
              <th>Details</th>
            </tr>
            ${order.items
              .map(
                (i) => `
                <tr>
                  <td>${i.public_id}</td>
                  <td>${i.quantity}</td>
                  <td>${i.color || ""} ${i.size || ""}</td>
                </tr>
              `
              )
              .join("")}
          </table>

          <div class="section-title">Payment Details</div>
          <p>Subtotal: $${order.subtotal.toFixed(2)}</p>
          <p>Discount: $${order.discount.toFixed(2)}</p>
          <p>Shipping: $${order.shippingCost.toFixed(2)}</p>
          ${
            extraAmount > 0
              ? `<p>Extra Fees: ${extraLabel ? `${extraLabel} ` : ""}$${extraAmount.toFixed(
                  2
                )}</p>`
              : ""
          }
          <p><b>Total: $${order.total.toFixed(2)}</b></p>

          <p><b>Note:</b> ${(order.orderNote || order.customer.note || "")}</p>

          <div class="section-title">Staff Notes</div>
          <div class="box">${order.adminNote || ""}</div>

          <script>
            window.print();
          </script>
        </body>
      </html>
    `);

    w.document.close();
  };

  const formatPlacedDate = (d) =>
  new Date(d).toLocaleDateString();

const formatPlacedTime = (d) =>
  new Date(d).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

const getSourceMeta = (source) => {
  switch (source) {
    case "website":
      return {
        label: TEXT.website,
        icon: <FaGlobe className="text-[12px] text-gray-500" />,
      };
    case "whatsapp":
      return {
        label: TEXT.whatsapp,
        icon: <FaWhatsapp className="text-[12px] text-gray-500" />,
      };
    case "store":
      return {
        label: TEXT.store,
        icon: <FaStore className="text-[12px] text-gray-500" />,
      };
    default:
      return {
        label: source || "—",
        icon: null,
      };
  }
};

const getStatusMeta = (status) => {
  switch (status) {
    case "pending":
      return {
        label: TEXT.status.pending,
        cls: "bg-amber-50 text-amber-700 border border-amber-200",
        dot: "bg-amber-500",
      };
    case "paid":
      return {
        label: lang === "EN" ? "Paid" : "مدفوع",
        cls: "bg-emerald-50 text-emerald-700 border border-emerald-200",
        dot: "bg-emerald-500",
      };
    case "shipped":
      return {
        label: TEXT.status.shipped,
        cls: "bg-blue-50 text-blue-700 border border-blue-200",
        dot: "bg-blue-500",
      };
    case "delivered":
      return {
        label: TEXT.status.delivered,
        cls: "bg-green-50 text-green-700 border border-green-200",
        dot: "bg-green-600",
      };
    case "cancelled":
      return {
        label: TEXT.status.cancelled,
        cls: "bg-red-50 text-red-700 border border-red-200",
        dot: "bg-red-500",
      };
    case "refunded":
      return {
        label: lang === "EN" ? "Refunded" : "مسترجع",
        cls: "bg-purple-50 text-purple-700 border border-purple-200",
        dot: "bg-purple-500",
      };
    default:
      return {
        label: status,
        cls: "bg-gray-100 text-gray-900 border border-gray-200",
        dot: "bg-gray-400",
      };
  }
};


const normalizePhone = (value = "") =>
  String(value).replace(/\D/g, "");

const normalizeEmail = (value = "") =>
  String(value).trim().toLowerCase();

const getOrdinal = (n) => {
  const num = Number(n || 0);

  if (lang === "AR") {
    return `${num}`;
  }

  const mod10 = num % 10;
  const mod100 = num % 100;

  if (mod10 === 1 && mod100 !== 11) return `${num}st`;
  if (mod10 === 2 && mod100 !== 12) return `${num}nd`;
  if (mod10 === 3 && mod100 !== 13) return `${num}rd`;
  return `${num}th`;
};

const matchedActivity = activityRows.find((row) => {
  const rowEmail = normalizeEmail(row.email);
  const orderEmail = normalizeEmail(order?.customer?.email);

  const rowPhone = normalizePhone(row.phone);
  const orderPhone = normalizePhone(order?.customer?.phone);

  if (rowEmail && orderEmail && rowEmail === orderEmail) return true;
  if (rowPhone && orderPhone && rowPhone === orderPhone) return true;

  return false;
});

const customerOrdersCount = Number(matchedActivity?.orders || 0);
const customerVisitsCount = Number(matchedActivity?.visits || 0);
const customerActionsCount = Number(matchedActivity?.actions || 0);
const customerLastVisit = matchedActivity?.lastVisit || "—";
const customerLastAction = matchedActivity?.lastAction || "—";

const conversionLine1 =
  matchedActivity
    ? lang === "EN"
      ? `This is their ${getOrdinal(customerOrdersCount)} order`
      : `هذا هو الطلب رقم ${getOrdinal(customerOrdersCount)} لهذا العميل`
    : lang === "EN"
    ? "No conversion data found for this customer"
    : "لا توجد بيانات تحويل لهذا العميل";

const conversionLine2 =
  matchedActivity
    ? lang === "EN"
      ? `${customerVisitsCount} recorded sessions`
      : `${customerVisitsCount} جلسات مسجلة`
    : lang === "EN"
    ? "Session data unavailable"
    : "بيانات الجلسات غير متوفرة";

const conversionLine3 =
  matchedActivity
    ? lang === "EN"
      ? `${customerActionsCount} actions recorded`
      : `${customerActionsCount} إجراءات مسجلة`
    : lang === "EN"
    ? "Action data unavailable"
    : "بيانات الإجراءات غير متوفرة";

    const customerPageId =
  order?.customer?.id ||
  order?.customerId ||
  matchedActivity?.id ||
  null;

  if (loading || !order) {
    return (
      <div className={`flex bg-[#f6f6f7] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
        <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
        <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full transition-all`}>
          <AdminHeader
              setIsOpen={setIsOpen}
              customCenter={
                <div
                  className={`
                    hidden sm:block
                    w-full
                    sm:max-w-[500px]
                    max-w-full
                    transition-all duration-300
                    ${isDirty ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
                  `}
                >
                  <div className="bg-[#2c2c2c] border border-[#3a3a3a] rounded-md px-3 py-2 sm:py-[4px] space-y-2 sm:space-y-0 sm:flex sm:items-center sm:justify-between">

                    {/* LEFT */}
                    <div className="flex items-center gap-2 text-[13px] text-gray-200 justify-between sm:justify-start">
                      <span>
                        {lang === "AR" ? "تغييرات غير محفوظة" : "Unsaved changes"}
                      </span>
                    </div>

                    {/* RIGHT */}
                    <div className="flex gap-2 sm:gap-1.5 w-full sm:w-auto">

                      {/* DISCARD */}
                      <button
                        type="button"
                        onClick={handleBackClick}
                        className="
                          px-2 py-[2px]
                          text-[12px]
                          rounded-md
                          border border-[#3a3a3a]
                          bg-[#1f1f1f]
                          hover:bg-[#363636]
                          text-gray-200
                          transition
                        "
                      >
                        {lang === "AR" ? "إلغاء" : "Discard"}
                      </button>

                      {/* SAVE */}
                      <button
                        type="button"
                        onClick={handleSave}
                        className="
                          px-2 py-[2px]
                          text-[12px]
                          rounded-md
                          font-medium
                          bg-white text-black hover:bg-gray-200
                          transition
                        "
                      >
                        {lang === "AR" ? "حفظ" : "Save"}
                      </button>

                    </div>
                  </div>
                </div>
              }
            />
          <div className="p-4 space-y-4 animate-pulse">

  {/* HEADER */}
  <div className="h-6 w-40 bg-gray-200 rounded"></div>

  {/* STATUS CARD */}
  <div className="bg-white border rounded-xl p-4 space-y-3">
    <div className="h-4 w-32 bg-gray-200 rounded"></div>
    <div className="h-10 w-full bg-gray-200 rounded"></div>
  </div>

  {/* PRODUCTS */}
  <div className="bg-white border rounded-xl p-4 space-y-3">
    <div className="h-4 w-28 bg-gray-200 rounded"></div>

    {[1,2,3].map(i => (
      <div key={i} className="flex items-center gap-3">
        <div className="w-10 h-10 bg-gray-200 rounded"></div>
        <div className="flex-1 space-y-2">
          <div className="h-3 w-40 bg-gray-200 rounded"></div>
          <div className="h-3 w-24 bg-gray-200 rounded"></div>
        </div>
        <div className="h-3 w-16 bg-gray-200 rounded"></div>
      </div>
    ))}
  </div>

  {/* SUMMARY */}
  <div className="bg-white border rounded-xl p-4 space-y-2">
    {[1,2,3].map(i => (
      <div key={i} className="flex justify-between">
        <div className="h-3 w-24 bg-gray-200 rounded"></div>
        <div className="h-3 w-16 bg-gray-200 rounded"></div>
      </div>
    ))}
  </div>

</div>
        </div>
      </div>
    );
  }

  const extraAmount = Number(order.extraFeeAmount || 0);
  const extraLabel = (order.extraFeeLabel || "").trim();

  const totalItemsQty = order.items.reduce(
  (sum, i) => sum + Number(i.quantity || 0),
          0
      );

      const subtotal = Number(order.subtotal || 0);
const discountAmount = Number(order.discount || 0);
const shipping = Number(order.shippingCost || 0);
const extraFees = Number(order.extraFeeAmount || 0);

const calculatedTotal = subtotal - discountAmount + shipping + extraFees;

      const statusMeta = getStatusMeta(order.status);
      const sourceMeta = getSourceMeta(order.orderSource);

      const statusOptions = ["pending", "paid", "shipped", "delivered", "cancelled", "refunded"];

      const paymentLabel =
        order.payment === "cod"
          ? lang === "EN"
            ? "Cash on delivery"
            : "الدفع عند الاستلام"
          : order.payment || "—";

          const timelineDateLabel = new Date(order.created_at).toLocaleDateString(
  lang === "AR" ? "ar-EG" : "en-US",
  {
    month: "long",
    day: "numeric",
  }
);

const timelineTimeLabel = new Date(order.created_at).toLocaleTimeString([], {
  hour: "numeric",
  minute: "2-digit",
});

const timelineCustomerName = order.customer?.name || TEXT.guest;
const timelineCustomerEmail = order.customer?.email || "—";
const timelineOrderNumber = order.orderNumber || order.id;
const timelineCheckoutId = order.orderNumber || order.id;

const timelineSourceLabel =
  order.orderSource === "website"
    ? (lang === "EN" ? "Online Store" : "المتجر الإلكتروني")
    : order.orderSource === "whatsapp"
    ? TEXT.whatsapp
    : order.orderSource === "store"
    ? TEXT.store
    : order.orderSource || TEXT.store;

    
  return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full transition-all`}>
        <AdminHeader
              setIsOpen={setIsOpen}
              customCenter={
                <div
                  className={`
                    hidden sm:block
                    w-full
                    sm:max-w-[500px]
                    max-w-full
                    transition-all duration-300
                    ${isDirty ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
                  `}
                >
                  <div className="bg-[#2c2c2c] border border-[#3a3a3a] rounded-md px-3 py-2 sm:py-[4px] space-y-2 sm:space-y-0 sm:flex sm:items-center sm:justify-between">

                    {/* LEFT */}
                    <div className="flex items-center gap-2 text-[13px] text-gray-200 justify-between sm:justify-start">
                      <span>
                        {lang === "AR" ? "تغييرات غير محفوظة" : "Unsaved changes"}
                      </span>
                    </div>

                    {/* RIGHT */}
                    <div className="flex gap-2 sm:gap-1.5 w-full sm:w-auto">

                      {/* DISCARD */}
                      <button
                        type="button"
                        onClick={handleBackClick}
                        className="
                          px-2 py-[2px]
                          text-[12px]
                          rounded-md
                          border border-[#3a3a3a]
                          bg-[#1f1f1f]
                          hover:bg-[#363636]
                          text-gray-200
                          transition
                        "
                      >
                        {lang === "AR" ? "إلغاء" : "Discard"}
                      </button>

                      {/* SAVE */}
                      <button
                        type="button"
                        onClick={handleSave}
                        className="
                          px-2 py-[2px]
                          text-[12px]
                          rounded-md
                          font-medium
                          bg-white text-black hover:bg-gray-200
                          transition
                        "
                      >
                        {lang === "AR" ? "حفظ" : "Save"}
                      </button>

                    </div>
                  </div>
                </div>
              }
            />

        <main className="p-3 sm:p-5 animate-fadeSlide">
         <div className="max-w-[1040px] mx-auto mx-1">
      {/* TOP HEADER */}

{/* MOBILE HEADER */}
<div className="lg:hidden mx-1 mb-3">
  <div className="flex items-start justify-between gap-3">
    {/* LEFT */}
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2">
        <button
          onClick={handleBackClick}
          className="shrink-0 flex items-center justify-center w-8 h-8 rounded-md text-[#202223] hover:bg-gray-200 transition"
        >
          <FaInbox className="text-[16px] text-gray-900" />
        </button>

        <div className="min-w-0">
          <div className="flex items-center gap-1.5 min-w-0">
            <FiChevronRight className="text-gray-400 text-[14px] shrink-0" />
            <h1 className="text-[15px] font-semibold text-[#202223] truncate">
              #{order.orderNumber}
            </h1>
          </div>

          <div className="mt-1">
            <span
              className={`inline-flex items-center gap-1.5 px-2 h-5 rounded-md text-[11px] font-medium ${statusMeta.cls}`}
            >
              <span className={`w-1.5 h-1.5 rounded-full ${statusMeta.dot}`}></span>
              {statusMeta.label}
            </span>
          </div>

          <div className="mt-1 text-[11px] text-[#6d7175] leading-5 flex flex-wrap items-center gap-1">
            {lang === "EN" ? (
              <>
                <span>
                  {new Date(order.created_at).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </span>
                <span>at</span>
                <span>
                  {new Date(order.created_at).toLocaleTimeString([], {
                    hour: "numeric",
                    minute: "2-digit",
                  })}
                </span>
                <span>from</span>
                <span className="inline-flex items-center gap-1 text-[#202223] font-medium">
                  {sourceMeta.icon}
                  {sourceMeta.label === TEXT.website ? TEXT.onlineStore : sourceMeta.label}
                </span>
              </>
            ) : (
              <>
                <span>
                  {new Date(order.created_at).toLocaleDateString("ar-EG", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </span>
                <span>في</span>
                <span>
                  {new Date(order.created_at).toLocaleTimeString("ar-EG", {
                    hour: "numeric",
                    minute: "2-digit",
                  })}
                </span>
                <span>من</span>
                <span className="inline-flex items-center gap-1 text-[#202223] font-medium">
                  {sourceMeta.icon}
                  {sourceMeta.label}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* RIGHT */}
    <div className="relative shrink-0">
      <button
        onClick={() => {
          setMobileHeaderMenuOpen((v) => {
            const next = !v;
            if (!next) {
              setMobileMoreActionsOpen(false);
              setEditMenuOpen(false);
            }
            return next;
          });
        }}
        className="mobile-header-menu-trigger w-9 h-9 rounded-[10px] border border-[#c9cccf] bg-gray-200 text-[#202223] flex items-center justify-center hover:bg-[#f1f2f3] transition mt-2"
      >
        <FaEllipsisH className="text-[14px]" />
      </button>

      {mobileHeaderMenuOpen && (
        <>
          <div className="fixed inset-0 z-40" />
          <div className="mobile-header-menu absolute right-0 mt-2 w-[220px] bg-white border border-[#e1e3e5] rounded-[12px] shadow-lg z-50 overflow-hidden">
            {editMode && (
              <button
                onClick={() => {
                  stopEditing();
                  setMobileHeaderMenuOpen(false);
                }}
                className="w-full text-left px-4 py-3 text-sm font-medium hover:bg-[#f6f6f7]"
              >
                {lang === "EN" ? "Done editing" : "إنهاء التعديل"}
              </button>
            )}

            <button
                onClick={() => {
                  scrollToOrderItemsEdit();
                  setMobileHeaderMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm hover:bg-[#f6f6f7]"
              >
                <FaPen className="text-[12px]" />
                {lang === "EN" ? "Edit order items" : "تعديل المنتجات"}
              </button>

              <button
                onClick={() => {
                  scrollToCustomerEdit();
                  setMobileHeaderMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm hover:bg-[#f6f6f7]"
              >
                <FaUserEdit className="text-[12px]" />
                {lang === "EN" ? "Edit customer" : "تعديل العميل"}
              </button>

            <button
              onClick={() => {
                printOrder(order);
                setMobileHeaderMenuOpen(false);
              }}
              className="w-full flex items-center gap-3 px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              <FaPrint className="text-[12px]" />
              {TEXT.print}
            </button>

            <button
              onClick={() => setMobileMoreActionsOpen((v) => !v)}
              className="w-full flex items-center justify-between px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              <span>{TEXT.moreActions}</span>
              <FaChevronDown
                className={`text-[11px] transition ${mobileMoreActionsOpen ? "rotate-180" : ""}`}
              />
            </button>

            {mobileMoreActionsOpen && (
              <div className="border-t border-[#f1f2f3] bg-[#fcfcfc]">
                <button
                  onClick={() => {
                    setOrder((prev) => ({ ...prev, status: "cancelled" }));
                    setMobileHeaderMenuOpen(false);
                    setMobileMoreActionsOpen(false);
                  }}
                  className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-[#f6f6f7]"
                >
                  <FiX className="text-black text-[14px]" />
                  {lang === "EN" ? "Cancel order" : "إلغاء الطلب"}
                </button>

                <button
                  onClick={() => {
                    scrollToOrderStatus();
                    setMobileHeaderMenuOpen(false);
                    setMobileMoreActionsOpen(false);
                  }}
                  className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-[#f6f6f7]"
                >
                  <FiTruck className="text-black text-[14px]" />
                  {lang === "EN" ? "Edit order status" : "تعديل حالة الطلب"}
                </button>

                <button
                  onClick={() => {
                    setDraftAdminNote(order.adminNote || "");
                    setAdminNoteOpen(true);
                    setMobileHeaderMenuOpen(false);
                    setMobileMoreActionsOpen(false);
                  }}
                  className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-[#f6f6f7]"
                >
                  <FiFileText className="text-black text-[14px]" />
                  {lang === "EN" ? "Add admin note" : "إضافة ملاحظة"}
                </button>

                <button
                  onClick={async () => {
                    try {
                      await deleteAdminOrder(order.id);
                      navigate("/admin/orders", { state: { showDeleteToast: true } });
                    } catch (e) {
                      alert(e.message);
                    }
                  }}
                  className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-red-50"
                >
                  <FiArchive className="text-black text-[14px]" />
                  {lang === "EN" ? "Archive order" : "أرشفة الطلب"}
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  </div>
</div>

{/* DESKTOP HEADER */}
<div className="hidden lg:block">
  <div className="mx-0.5 flex items-center justify-between">
    {/* LEFT SIDE */}
    <div className="flex items-center">
      <button
        onClick={handleBackClick}
        className="
        flex items-center justify-center
        w-8 h-8
        rounded-md
        text-[#202223]
        hover:bg-gray-200
        transition
        "
      >
        <FaInbox className="text-[16px] text-gray-900" />
      </button>

      <div className="flex items-center gap-2">
        <FiChevronRight className="text-gray-400 text-[15px]" />
        <h1 className="text-[17px] font-semibold text-[#202223]">
          #{order.orderNumber}
        </h1>

        <span
          className={`inline-flex items-center gap-1.5 px-2 h-5 rounded-md text-[11px] font-medium ${statusMeta.cls}`}
        >
          <span className={`w-1.5 h-1.5 rounded-full ${statusMeta.dot}`}></span>
          {statusMeta.label}
        </span>
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div className="flex items-center gap-2">
      <div className="relative edit-menu-trigger">
        {editMode && (
          <button
            onClick={stopEditing}
            className="
            mx-2
            h-8 px-3
            rounded-[10px]
            border border-[#c9cccf]
            bg-[#202223]
            text-white
            text-sm font-medium
            hover:bg-black
            transition
            "
          >
            {lang === "EN" ? "Done editing" : "إنهاء التعديل"}
          </button>
        )}

        <button
          onClick={() => setEditMenuOpen((v) => !v)}
          className="
          h-8 px-3
          rounded-[10px]
          border border-[#c9cccf]
          bg-gray-200
          text-[#202223]
          text-sm font-medium
          hover:bg-[#f1f2f3]
          transition
          "
        >
          <span className="flex items-center gap-2">
            <FaPen className="text-[12px]" />
            {TEXT.edit}
          </span>
        </button>

        {editMenuOpen && (
          <div className="absolute right-0 mt-2 w-[220px] bg-white border border-[#e1e3e5] rounded-[12px] shadow-lg z-40 overflow-hidden">
            <button
              onClick={() => {
                setEditingCustomer(false);
                setCustomerDraft(null);
                setEditMode("items");
                setEditMenuOpen(false);
              }}
              className="w-full text-left px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              {lang === "EN" ? "Edit order" : "تعديل الطلب"}
            </button>

            <button
              onClick={() => {
                startEditCustomer();
                setEditMode("customer");
                setEditMenuOpen(false);
              }}
              className="w-full text-left px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              {lang === "EN" ? "Edit customer" : "تعديل العميل"}
            </button>
          </div>
        )}
      </div>

      <button
        onClick={() => printOrder(order)}
        className="
        h-8 px-3
        rounded-[10px]
        border border-[#c9cccf]
        bg-gray-200
        text-[#202223]
        text-sm font-medium
        hover:bg-[#f1f2f3]
        transition
        "
      >
        <span className="flex items-center gap-2">
          <FaPrint className="text-[12px]" />
          {TEXT.print}
        </span>
      </button>

      <div className="relative actions-menu-trigger">
        <button
          onClick={() => setActionsMenuOpen((v) => !v)}
          className="
          h-8 px-3
          rounded-[10px]
          border border-[#c9cccf]
          bg-gray-200
          text-[#202223]
          text-sm font-medium
          hover:bg-[#f1f2f3]
          transition
          "
        >
          <span className="flex items-center gap-2">
            {TEXT.moreActions}
            <FaChevronDown className="text-[11px]" />
          </span>
        </button>

        {actionsMenuOpen && (
          <div className="
          absolute right-0 mt-2 w-[240px]
          bg-white
          border border-[#e1e3e5]
          rounded-[12px]
          shadow-lg
          z-40
          overflow-hidden
          ">
            <button
              onClick={() => {
                setOrder((prev) => ({ ...prev, status: "cancelled" }));
                setActionsMenuOpen(false);
              }}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              <FiX className="text-black text-[14px]" />
              {lang === "EN" ? "Cancel order" : "إلغاء الطلب"}
            </button>

            <button
              onClick={() => {
                scrollToOrderStatus();
                setActionsMenuOpen(false);
              }}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              <FiTruck className="text-black text-[14px]" />
              {lang === "EN" ? "Edit order status" : "تعديل حالة الطلب"}
            </button>

            <button
              onClick={() => {
                setDraftAdminNote(order.adminNote || "");
                setAdminNoteOpen(true);
                setActionsMenuOpen(false);
              }}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-[#f6f6f7]"
            >
              <FiFileText className="text-black text-[14px]" />
              {lang === "EN" ? "Add admin note" : "إضافة ملاحظة"}
            </button>

            <button
              onClick={async () => {
                try {
                  await deleteAdminOrder(order.id);
                  navigate("/admin/orders", { state: { showDeleteToast: true } });
                } catch (e) {
                  alert(e.message);
                }
              }}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-red-50"
            >
              <FiArchive className="text-black text-[14px]" />
              {lang === "EN" ? "Archive order" : "أرشفة الطلب"}
            </button>
          </div>
        )}
      </div>
    </div>
  </div>

  {/* DESKTOP ORDER META */}
  <div className="mx-2 text-[12px] text-[#6d7175] mb-3 flex items-center gap-1 flex-wrap">
    {lang === "EN" ? (
      <>
        <span>
          {new Date(order.created_at).toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </span>

        <span>at</span>

        <span>
          {new Date(order.created_at).toLocaleTimeString([], {
            hour: "numeric",
            minute: "2-digit",
          })}
        </span>

        <span>from</span>

        <span className="flex items-center gap-1 text-[#202223] font-medium">
          {sourceMeta.icon}
          {sourceMeta.label === TEXT.website ? TEXT.onlineStore : sourceMeta.label}
        </span>
      </>
    ) : (
      <>
        <span>
          {new Date(order.created_at).toLocaleDateString("ar-EG", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </span>

        <span>في</span>

        <span>
          {new Date(order.created_at).toLocaleTimeString("ar-EG", {
            hour: "numeric",
            minute: "2-digit",
          })}
        </span>

        <span>من</span>

        <span className="flex items-center gap-1 text-[#202223] font-medium">
          {sourceMeta.icon}
          {sourceMeta.label}
        </span>
      </>
    )}
  </div>
</div>   

          {/* Status */}
          <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_340px] gap-3">

{/* ORDER STATUS */}
<div className="xl:col-start-2 xl:row-start-1 xl:mb-2">
<section
  ref={orderStatusRef}
  className="
  order-1 xl:order-none
  bg-white
  border border-[#e1e3e5]
  shadow-sm
  -mx-3 rounded-none
  lg:mx-0 lg:rounded-[18px]
  "
>
  <div className="p-4">

    <h2 className="text-[15px] font-semibold text-[#202223] mb-3">
      {TEXT.orderStatus}
    </h2>

    <div className="relative status-menu-trigger">

      {/* CURRENT STATUS BADGE */}
      <button
        onClick={() => setStatusMenuOpen((v) => !v)}
        className={`w-full flex items-center justify-between px-3 h-[38px] rounded-[10px] border text-sm font-medium ${statusMeta.cls}`}
      >
        <span className="flex items-center gap-2">
          <span className={`w-2 h-2 rounded-full ${statusMeta.dot}`} />
          {statusMeta.label}
        </span>

        <span className="text-[12px]">▼</span>
      </button>

      {/* DROPDOWN */}
      {statusMenuOpen && (
        <div className="absolute z-20 mt-2 w-full bg-white border border-[#e1e3e5] rounded-[12px] shadow-lg overflow-hidden">

          {statusOptions.map((s) => {
            const meta = getStatusMeta(s);

            return (
              <button
                key={s}
                onClick={() => {
                  setOrder((prev) => ({ ...prev, status: s }));
                  setStatusMenuOpen(false);
                }}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-[#f6f6f7] transition"
              >
                <span className={`w-2 h-2 rounded-full ${meta.dot}`} />
                <span className="text-[#202223]">{meta.label}</span>
              </button>
            );
          })}

        </div>
      )}

    </div>

  </div>
</section>
</div>
    {/* PRODUCTS */}
    <div className="xl:col-start-1 xl:row-start-1">
   <section
  ref={itemsSectionRef}
  className="
  order-2 xl:order-none
  bg-white
  border border-[#e1e3e5]
  shadow-sm
  overflow-hidden
  -mx-3 rounded-none
  lg:mx-0 lg:rounded-[18px]
  "
>
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[15px] font-semibold text-[#202223]">
            {TEXT.products}
          </h2>

          {editMode==="items" && (
              <button
              onClick={() => setShowAddItem(true)}
              className="h-[36px] px-4 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] text-sm font-medium hover:bg-[#f1f2f3] transition"
              >
              + {lang === "EN" ? "Add item" : "إضافة منتج"}
              </button>
              )}
        </div>

        {order.items.length === 0 ? (
          <div className="text-center py-10 text-[#6d7175] space-y-2">
  <FaBoxOpen className="mx-auto text-2xl opacity-40" />
  <p className="text-sm">{TEXT.noProducts}</p>

  {editMode === "items" && (
    <button
      onClick={() => setShowAddItem(true)}
      className="text-sm text-[#1a73e8] hover:underline"
    >
      {lang === "EN" ? "Add first product" : "إضافة أول منتج"}
    </button>
  )}
</div>
          ) : (
          <div className="overflow-hidden rounded-[14px] border border-[#e1e3e5]">
            <div className="grid grid-cols-[minmax(0,1fr)_160px_120px_40px] bg-[#f6f6f7] text-xs font-semibold text-[#6d7175] px-4 py-2">
              <div>{lang === "EN" ? "Product" : "المنتج"}</div>
              <div className="text-center">{lang === "EN" ? "Variant" : "النوع"}</div>
              <div className="text-right">{TEXT.total}</div>
              <div></div>
            </div>

            {order.items.map((item) => (
  <div
    key={item.id}
    className="grid grid-cols-[minmax(0,1fr)_160px_120px_40px] items-center px-4 py-3 border-t border-[#f1f2f3] bg-white"
  >
    {/* PRODUCT */}
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5] flex-shrink-0">
        <img
          src={item.image}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="min-w-0">
        <div className="text-sm font-semibold text-[#202223] truncate">
          {lang === "EN" ? item.title_en : item.title_ar}
        </div>

        <div className="text-xs text-[#6d7175] truncate">
          {item.public_id || "—"}
        </div>
      </div>
    </div>

    {/* VARIANT */}
    <div className="text-center text-sm text-[#6d7175]">
      {item.color || "-"} / {item.size || "-"}
    </div>

    {/* PRICE */}
<div className="text-right">
  <div className="text-sm font-medium text-[#202223]">
    {item.isBxgyFree || item.bxgyType === "free"
      ? lang === "AR"
        ? "مجاني"
        : "FREE"
      : formatPrice(Number(item.quantity || 0) * Number(item.price || 0))}
  </div>

  <div className="text-xs text-[#6d7175]">
    {item.quantity} × {formatItemPriceLabel(item)}
  </div>

  {(item.isBxgyFree || item.bxgyType === "free") && (
    <div className="mt-1 text-[11px] font-semibold text-green-700">
      {lang === "AR" ? "هدية مجانية" : "Free gift"}
    </div>
  )}

  {(item.isBxgyDiscounted || item.bxgyType === "percentage") && (
    <div className="mt-1 text-[11px] font-semibold text-green-700">
      {lang === "AR"
        ? `خصم ${Number(item.bxgyDiscountValue || 0)}%`
        : `${Number(item.bxgyDiscountValue || 0)}% OFF`}
    </div>
  )}
</div>

    {/* REMOVE */}
    <div className="flex justify-end">
      {editMode==="items" && (
      <button
        onClick={async () => {
          setItemToDelete(item);
          const fresh = await getAdminOrderById(order.id);
          setOrder({ ...fresh, _originalStatus: fresh.status });
        }}
        className="w-7 h-7 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3] transition"
        title="Remove item"
      >
        ✕
      </button>
      )}
    </div>
  </div>
))}
          </div>
        )}
      </div>
    </section>
</div>
    {/* ORDER SUMMARY */}
    <div className="xl:col-start-1 xl:row-start-2">
    <section
  className="
  order-3 xl:order-none
  bg-white
  border border-[#e1e3e5]
  shadow-sm
  overflow-hidden
  -mx-3 rounded-none
  lg:mx-0 lg:rounded-[18px]
  "
>
      <div className="p-4">
        <h2 className="text-[15px] font-semibold text-[#202223] mb-4">
          {TEXT.orderSummary}
        </h2>

        <div className="border border-[#e1e3e5] rounded-[14px] bg-[#fcfcfc] overflow-hidden">
          <div className="text-[14px]">

            <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3">
              <span className="text-[#202223] font-medium">{TEXT.subtotal}</span>
              <span className="text-[#6d7175] text-center">
                {totalItemsQty} {lang === "EN" ? "items" : "قطعة"}
              </span>
              <span className="text-right font-medium">${order.subtotal.toFixed(2)}</span>
            </div>

            <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3 border-[#f1f2f3]">

  <button
    onClick={() => {
          setDraftDiscount(
            order.discountType === "percent"
              ? Number(order.discountInput || 0)
              : Number(order.discount || 0)
          );

          setDiscountType(order.discountType || "fixed");
          setDiscountModalOpen(true);
        }}
    className={`text-[#1a73e8] font-medium hover:underline ${lang === "EN" ? "text-left" : "text-right"}`}
  >
    {order.discount > 0
      ? lang === "EN" ? "Edit discount" : "تعديل الخصم"
      : lang === "EN" ? "Add discount" : "إضافة خصم"}
  </button>

  <span className="text-center text-[#6d7175]">
  {discountAmount > 0
  ? order.discountType === "percent"
    ? `${order.discountInput}%`
    : `${lang==="EN" ? "fixed" : "ثابت"} ${order.discountInput}$`
  : "—"}
</span>

  <span className="text-right text-[#202223]">
        {discountAmount > 0
          ? `− $${discountAmount.toFixed(2)}`
          : "$0.00"}
      </span>

</div>

            <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3 border-[#f1f2f3]">
              <span className="text-[#202223] font-medium">{TEXT.shipping}</span>
              <span className="text-center text-[#6d7175]">
                {order.shippingMethod === "pickup"
                  ? lang === "EN"
                    ? "Pickup"
                    : "استلام"
                  : lang === "EN"
                  ? "Delivery"
                  : "توصيل"}
              </span>
              <span className="text-right text-[#202223]">
                ${order.shippingCost.toFixed(2)}
              </span>
            </div>

            <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3 border-[#f1f2f3]">

  <button
    onClick={() => {
      setDraftExtraLabel(order.extraFeeLabel || "");
      setDraftExtraAmount(order.extraFeeAmount || 0);
      setExtraFeesModalOpen(true);
    }}
    className={`text-[#1a73e8] font-medium hover:underline ${lang === "EN" ? "text-left" : "text-right"}`}
  >
    {TEXT.extraFees}
  </button>

  <span className="text-center text-[#6d7175]">
    {extraLabel || "—"}
  </span>

  <span className="text-right text-[#202223]">
    {extraAmount > 0 ? `$${extraAmount.toFixed(2)}` : "$0.00"}
  </span>

</div>

            <div className="grid grid-cols-[1fr_120px_120px] items-center px-4 py-4 font-semibold text-[15px] border-t border-[#f1f2f3]">
              <span>{TEXT.total}</span>
              <span></span>
              <span className="text-right">${calculatedTotal.toFixed(2)}</span>
            </div>

          </div>
        </div>
      </div>
    </section>
</div>
    
    {/* PAYMENT */}
   <div className="xl:col-start-1 xl:row-start-3 xl:-mt-1">
  <section
className="
order-4 xl:order-none
bg-white
border border-[#e1e3e5]
shadow-sm
-mx-3 rounded-none
lg:mx-0 lg:rounded-[18px]
"
>
  <div className="p-4">

    <h2 className="text-[15px] font-semibold text-[#202223] mb-4">
      {TEXT.payment}
    </h2>

    <div className="grid grid-cols-2 gap-3">

      <div className="border border-[#e1e3e5] rounded-[14px] px-4 py-3">
        <div className="text-xs font-semibold text-[#6d7175] mb-1">
          {TEXT.paymentMethod}
        </div>

        <div className="text-sm text-[#202223] font-medium">
          {paymentLabel}
        </div>
      </div>

      <div className="border border-[#e1e3e5] rounded-[14px] px-4 py-3">
        <div className="text-xs font-semibold text-[#6d7175] mb-1">
          {TEXT.shippingMethod}
        </div>

        <span
          className={`inline-flex items-center justify-center px-2.5 py-[2px] rounded-md text-[12px] font-medium border ${
            order.shippingMethod === "pickup"
              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
              : "bg-blue-50 text-blue-700 border-blue-200"
          }`}
        >
          {order.shippingMethod === "pickup"
            ? lang === "EN"
              ? "Pickup"
              : "استلام"
            : lang === "EN"
            ? "Delivery"
            : "توصيل"}
        </span>

      </div>

    </div>

  </div>
</section>
</div>

{/* CUSTOMER */}
<div className="xl:col-start-2 xl:row-start-2 xl:-mt-[62px]">
    <section
  ref={customerSectionRef}
  className="
  order-5 xl:order-none
  bg-white
  border border-[#e1e3e5]
  shadow-sm
  overflow-visible
  -mx-3 rounded-none
  lg:mx-0 lg:rounded-[18px]
"
>
      <div className="p-5">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-[13px] font-semibold text-gray-800">
            {TEXT.customerDetails}
          </h2>

          {editMode === "customer" ? (
              <button
                onClick={saveCustomerDetails}
                className="h-[36px] px-4 rounded-[10px] bg-[#202223] text-white text-sm font-medium hover:bg-black transition"
              >
                {TEXT.save}
              </button>
            ) : null}
        </div>

        {editMode!=="customer" ? (
          <div className="bg-white">
            <div className="px-2 pt-0.5">
  <div className="relative inline-block">
    <button
      type="button"
      className="customer-trigger group flex items-center gap-1 text-left"
      onClick={(e) => {
        e.stopPropagation();
        setCustomerOverlayOpen((v) => !v);
      }}
    >
      <span className="text-[14px] font-semibold text-[#1a73e8] hover:underline">
        {order.customer.name || TEXT.guest}
      </span>

      <span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
        <FiChevronDown className="text-[16px]" />
      </span>
    </button>

    <div className="text-[12px] text-gray-500 mt-0.5">
      {customerOrdersCount} {lang === "EN" ? "orders" : "طلبات"}
    </div>

    {customerOverlayOpen && (
      <div
        className="
        customer-overlay
        absolute
        left-0
        top-full
        mt-2
        w-[270px]
        bg-white
        border border-gray-200
        rounded-[14px]
        shadow-[0_25px_60px_rgba(0,0,0,0.20)]
        z-50
        animate-sortOverlay
        "
      >
        <div className="px-4 pt-3 pb-2">
          <div className="text-[15px] font-semibold text-gray-900 leading-tight">
            {order.customer.name || TEXT.guest}
          </div>

          {order.customer.phone && (
            <div className="text-[13px] text-blue-600 mt-[2px]">
              {order.customer.phone}
            </div>
          )}

          {order.customer.email && (
            <div className="text-[12.5px] text-gray-500">
              {order.customer.email}
            </div>
          )}
        </div>

        <div className="px-4 pb-3 text-[12px] text-gray-500">
          {customerOrdersCount} {lang === "EN" ? "orders" : "طلبات"}
        </div>

        <div className="border-t border-gray-200"></div>

        <div className="p-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (customerPageId) {
                navigate(`/admin/customers/${customerPageId}`);
              }
            }}
            disabled={!customerPageId}
            className="
            w-full
            flex items-center justify-center gap-2
            h-[34px]
            bg-[#f6f6f7]
            border border-gray-300
            rounded-lg
            text-[13px] font-medium text-gray-800
            shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
            hover:bg-gray-100
            active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
            transition
            disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            <FaEye className="text-[12px] text-gray-600" />
            {lang === "EN" ? "View customer" : "عرض العميل"}
          </button>
        </div>
      </div>
    )}
  </div>
</div>

            <div className="px-2 pt-4">
  <div className="text-[13px] text-gray-800 font-semibold mb-1">
    {TEXT.contactInformation}
  </div>

  {order.customer.email && (
    <div className="text-sm text-[#1a73e8]">
      {order.customer.email}
    </div>
  )}

  <div className="text-sm text-[#202223]">
    {order.customer.phone || "—"}
  </div>
</div>

<div className="px-2 py-4">
  <div className="text-[13px] text-gray-800 font-semibold mb-1">
    {TEXT.shippingAddress}
  </div>

  <div className="text-sm text-[#202223] leading-relaxed">
    {order.customer.name || TEXT.guest}
    <br />
    {order.customer.area || "—"}
    <br />
    {order.customer.street || "—"}
    <br />
    {order.customer.governorate || "—"}
    <br />
    {order.customer.building || "—"}
  </div>
</div>

            {order.orderNote && (
              <div className="mx-4 mb-4 p-3 rounded-[12px] bg-[#fff7e6] border border-[#f1e3c2] text-sm text-[#8a6116]">
                <b>{lang === "EN" ? "Order note:" : "ملاحظة الطلب:"}</b> {order.orderNote}
              </div>
            )}
          </div>
        ) : (
          <div className="space-y-3">
            <input
              value={customerDraft.name}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, name: e.target.value }))}
              placeholder={TEXT.name}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />

            <input
              value={customerDraft.phone}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, phone: e.target.value }))}
              placeholder={TEXT.phone}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />

            <input
              value={customerDraft.email}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, email: e.target.value }))}
              placeholder={TEXT.email}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />

            <input
              value={customerDraft.governorate}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, governorate: e.target.value }))}
              placeholder={TEXT.governorate}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />

            <input
              value={customerDraft.area}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, area: e.target.value }))}
              placeholder={lang === "EN" ? "Area" : "المنطقة"}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />

            <input
              value={customerDraft.street}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, street: e.target.value }))}
              placeholder={lang === "EN" ? "Street" : "الشارع"}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />

            <input
              value={customerDraft.building}
              onChange={(e) => setCustomerDraft((p) => ({ ...p, building: e.target.value }))}
              placeholder={lang === "EN" ? "Building" : "المبنى"}
              className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
            />
          </div>
        )}
      </div>
    </section>
    </div>

    {/* ADMIN NOTE */}
   <div className="xl:col-start-2 xl:row-start-3 xl:-mt-[8px]"> 
  <section
className="
order-6 xl:order-none
bg-white
border border-[#e1e3e5]
shadow-sm
-mx-3 rounded-none
lg:mx-0 lg:rounded-[18px]
"
>
  <div className="p-4">
    <div className="flex items-start justify-between gap-3">

      <div>
        <h2 className="text-[15px] font-semibold text-[#202223]">
          {lang === "EN" ? "Admin note" : "ملاحظة داخلية"}
        </h2>

        <p className="text-[15px] text-[#6d7175] mt-2 whitespace-pre-wrap">
          {order.adminNote?.trim()
            ? order.adminNote
            : TEXT.noNotes}
        </p>
      </div>

      <button
        type="button"
        onClick={() => {
          setDraftAdminNote(order.adminNote || "");
          setAdminNoteOpen(true);
        }}
        className="w-8 h-8 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3] transition"
      >
        <FaPen />
      </button>

    </div>
  </div>
</section>
</div>

 {/* CONVERSION SUMMARY */}
 <div className="xl:col-start-2 xl:row-start-4 xl:-mt-[48px]">
          <section
className="
order-7 xl:order-none
bg-white
border border-[#e1e3e5]
shadow-sm
-mx-3 rounded-none
lg:mx-0 lg:rounded-[18px]
"
>
          <div className="p-5">

            <h2 className="text-[15px] font-semibold text-black mb-4">
              {lang === "EN" ? "Conversion summary" : "ملخص التحويل"}
            </h2>

            <div className="space-y-2 text-[14px] text-[#6d7175]">

            <div className="flex items-center gap-2">
              <FaShoppingCart className="text-[13px] text-gray-900" />
              <span className="text-gray-900">{conversionLine1}</span>
            </div>

            <div className="flex items-center gap-2">
              <FaMousePointer className="text-[13px] text-gray-900" />
              <span className="text-gray-900">{conversionLine2}</span>
            </div>

            <div className="flex items-center gap-2">
              <FaChartLine className="text-[13px] text-gray-900" />
              <span className="text-gray-900">{conversionLine3}</span>
            </div>

          </div>

            <button
              onClick={() => setConversionModalOpen(true)}
              className="text-[#1a73e8] font-medium text-left hover:underline mt-2"
            >
              {lang === "EN"
                ? "View conversion details"
                : "عرض تفاصيل التحويل"}
            </button>

          </div>
        </section>
        </div>
    {/* TIMELINE */}
    <div className="xl:col-start-1 xl:row-start-4">
    <section className="order-8 xl:order-none overflow-hidden">
      <div className="p-4">
        <h2 className="text-[15px] font-semibold text-[#202223] mb-5">
          {lang === "EN" ? "Timeline" : "الخط الزمني"}
        </h2>

        <div className="text-[14px] text-[#202223] font-medium mb-4">
          {timelineDateLabel}
        </div>

        <div
  className={`
    relative
    ${lang === "EN" ? "pl-8 text-left" : "pr-8 text-right"}
  `}
>
          {/* vertical line */}
          <div className={`absolute ${lang==="EN"?"left-[7px]":"right-[7px]"} top-2 bottom-2 w-px bg-[#d9d9d9]`} />

          {/* line 1 */}
          <div className="relative mb-5">
      <span
  className={`
    absolute ${lang === "EN" ? "left-[-33px]" : "right-[-33px]"}
    top-[4px]
    w-[14px] h-[14px]
    bg-[#e5e5e5]
    rounded-[4px]
    flex items-center justify-center
  `}
>
  <span className="w-[6px] h-[6px] bg-[#202223] rounded-[2px]" />
</span>

            <div className="flex items-start justify-between gap-4">
              <p className="text-[14px] text-[#202223] leading-6">
                {lang === "EN" ? (
                  <>
                    Order confirmation email was sent to {timelineCustomerName} (
                    {timelineCustomerEmail}).
                  </>
                ) : (
                  <>
                    تم إرسال بريد تأكيد الطلب إلى {timelineCustomerName} (
                    {timelineCustomerEmail}).
                  </>
                )}
              </p>

              <span className="shrink-0 text-[12px] text-[#6d7175]">
                {timelineTimeLabel}
              </span>
            </div>
          </div>

          {/* line 2 */}
          <div className="relative mb-5">
         <span
  className={`
    absolute ${lang === "EN" ? "left-[-33px]" : "right-[-33px]"}
    top-[4px]
    w-[14px] h-[14px]
    bg-[#e5e5e5]
    rounded-[4px]
    flex items-center justify-center
  `}
>
  <span className="w-[6px] h-[6px] bg-[#202223] rounded-[2px]" />
</span>

            <div className="flex items-start justify-between gap-4">
              <p className="text-[14px] text-[#202223] leading-6">
                {lang === "EN" ? (
                  <>Confirmation #{timelineOrderNumber} was generated for this order.</>
                ) : (
                  <>تم إنشاء التأكيد #{timelineOrderNumber} لهذا الطلب.</>
                )}
              </p>

              <span className="shrink-0 text-[12px] text-[#6d7175]">
                {timelineTimeLabel}
              </span>
            </div>
          </div>

          {/* line 3 */}
          <div className="relative">
        <span
  className={`
    absolute ${lang === "EN" ? "left-[-33px]" : "right-[-33px]"}
    top-[4px]
    w-[14px] h-[14px]
    bg-[#e5e5e5]
    rounded-[4px]
    flex items-center justify-center
  `}
>
  <span className="w-[6px] h-[6px] bg-[#202223] rounded-[2px]" />
</span>

            <div className="flex items-start justify-between gap-4">
              <p className="text-[14px] text-[#202223] leading-6">
                {lang === "EN" ? (
                  <>
                  {timelineCustomerName} placed this order on {timelineSourceLabel} (checkout #{timelineCheckoutId})
                  </>
                  ) : (
                  <>
                  قام {timelineCustomerName} بإنشاء هذا الطلب من خلال {timelineSourceLabel} (checkout #{timelineCheckoutId})
                  </>
                  )}
              </p>

              <span className="shrink-0 text-[12px] text-[#6d7175]">
                {timelineTimeLabel}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
</div>
</div>

{editMode === "items" && (
  <div className="lg:hidden fixed bottom-5 left-1/2 -translate-x-1/2 z-50">
    <button
      onClick={stopEditing}
      className="
      bg-[#202223]
      text-white
      px-5
      h-[42px]
      rounded-[12px]
      shadow-xl
      text-sm
      font-semibold
      "
    >
      {lang === "EN" ? "Done editing" : "إنهاء التعديل"}
    </button>
  </div>
)}

          {showToast && (
  <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] animate-fadeSlide">
    <div className="
      bg-[#202223]
      text-white
      px-4
      py-3
      rounded-[12px]
      shadow-[0_8px_30px_rgba(0,0,0,0.25)]
      flex items-center gap-3
      text-[14px]
      font-medium
    ">
      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20">
        ✓
      </div>

      <span>
        {lang === "EN"
          ? "Order updated"
          : "تم تحديث الطلب"}
      </span>
    </div>
  </div>
)}

          {showCustomerToast && (
  <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] animate-fadeSlide">
    <div className="
      bg-[#202223]
      text-white
      px-4
      py-3
      rounded-[12px]
      shadow-[0_8px_30px_rgba(0,0,0,0.25)]
      flex items-center gap-3
      text-[14px]
      font-medium
    ">
      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20">
        ✓
      </div>

      <span>
        {lang === "EN"
          ? "Customer updated"
          : "تم تحديث العميل"}
      </span>
    </div>
  </div>
)}

{conversionModalOpen && (
<div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

  <div className="w-full max-w-[640px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl overflow-hidden">

    {/* HEADER */}
    <div className="px-6 py-4 border-b border-[#e1e3e5] bg-[#f6f6f7] flex items-center justify-between">

      <h3 className="text-[16px] font-semibold text-[#202223]">
        {lang === "EN"
          ? "Conversion details"
          : "تفاصيل التحويل"}
      </h3>

      <button
        onClick={() => setConversionModalOpen(false)}
        className="w-8 h-8 flex items-center justify-center rounded-md text-[#6d7175] hover:bg-[#f1f2f3]"
      >
        ✕
      </button>

    </div>

    {/* BODY */}
    <div className="p-6 text-sm text-[#6d7175] space-y-4">

          {!matchedActivity ? (
            <div className="text-center py-10 text-[#6d7175] space-y-2">
                <FaChartLine className="mx-auto text-2xl opacity-40" />
                <p className="text-sm">
                  {lang === "EN"
                    ? "No activity data for this customer"
                    : "لا توجد بيانات لهذا العميل"}
                </p>
              </div>
          ) : (
            <>
              <div className="grid grid-cols-2 gap-3">
                <div className="border border-[#e1e3e5] rounded-[12px] p-3 bg-[#fcfcfc]">
                  <div className="text-xs text-[#6d7175] mb-1">
                    {lang === "EN" ? "Orders" : "الطلبات"}
                  </div>
                  <div className="text-[15px] font-semibold text-[#202223]">
                    {customerOrdersCount}
                  </div>
                </div>

                <div className="border border-[#e1e3e5] rounded-[12px] p-3 bg-[#fcfcfc]">
                  <div className="text-xs text-[#6d7175] mb-1">
                    {lang === "EN" ? "Sessions" : "الجلسات"}
                  </div>
                  <div className="text-[15px] font-semibold text-[#202223]">
                    {customerVisitsCount}
                  </div>
                </div>

                <div className="border border-[#e1e3e5] rounded-[12px] p-3 bg-[#fcfcfc]">
                  <div className="text-xs text-[#6d7175] mb-1">
                    {lang === "EN" ? "Actions" : "الإجراءات"}
                  </div>
                  <div className="text-[15px] font-semibold text-[#202223]">
                    {customerActionsCount}
                  </div>
                </div>

                <div className="border border-[#e1e3e5] rounded-[12px] p-3 bg-[#fcfcfc]">
                  <div className="text-xs text-[#6d7175] mb-1">
                    {lang === "EN" ? "Customer email" : "بريد العميل"}
                  </div>
                  <div className="text-[13px] font-medium text-[#202223] break-all">
                    {matchedActivity.email || "—"}
                  </div>
                </div>
              </div>

              <div className="border border-[#e1e3e5] rounded-[12px] p-4 bg-gray-100 space-y-3">
                <div>
                  <div className="text-xs font-semibold text-[#6d7175] mb-1">
                    {lang === "EN" ? "Last visit" : "آخر زيارة"}
                  </div>
                  <div className="text-sm text-[#202223]">
                    {customerLastVisit}
                  </div>
                </div>

                <div>
                  <div className="text-xs font-semibold text-[#6d7175] mb-1">
                    {lang === "EN" ? "Last action" : "آخر إجراء"}
                  </div>
                  <div className="text-sm text-[#202223]">
                    {customerLastAction}
                  </div>
                </div>
              </div>
            </>
          )}

        </div>

    {/* FOOTER */}
    <div className="px-6 py-4 border-t border-[#e1e3e5] flex justify-end bg-gray-100">

      <button
        onClick={() => setConversionModalOpen(false)}
        className="h-[36px] px-4 rounded-[8px] border border-[#c9cccf] bg-white text-sm hover:bg-[#f1f2f3]"
      >
        {TEXT.cancel}
      </button>

    </div>

  </div>

</div>
)}

          {showConfirm && (
            <div className="fixed inset-0 bg-black/40 z-[9998] flex items-center justify-center">
  <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-[0_20px_60px_rgba(0,0,0,0.25)] overflow-hidden">

    {/* HEADER */}
    <div className="px-6 py-4 border-b border-[#e1e3e5] bg-[#f6f6f7]">
      <h3 className="text-[16px] font-semibold text-[#202223]">
        {lang === "EN" ? "Save changes" : "حفظ التغييرات"}
      </h3>
    </div>

    {/* BODY */}
    <div className="px-6 py-5">
      <p className="text-[14px] text-[#6d7175] leading-6">
        {lang === "EN"
          ? "Are you sure you want to update this order?"
          : "هل أنت متأكد من تحديث هذا الطلب؟"}
      </p>
    </div>

    {/* FOOTER */}
    <div className="px-6 py-4 border-t border-[#e1e3e5] flex justify-end gap-3 bg-[#f6f6f7]">

      {/* CANCEL */}
      <button
        onClick={() => setShowConfirm(false)}
        className="
          h-[36px] px-4
          rounded-[10px]
          border border-[#c9cccf]
          bg-white
          text-[14px] font-medium text-[#202223]
          hover:bg-[#f1f2f3]
          transition
        "
      >
        {TEXT.cancel}
      </button>

      {/* PRIMARY SAVE */}
      <button
  onClick={updateOrderStatus}
  disabled={saving}
  className="
    h-[36px] px-4
    rounded-[10px]
    bg-[#202223]
    text-white
    text-[14px] font-semibold
    hover:bg-black
    transition
    disabled:opacity-50
    disabled:cursor-not-allowed
  "
>
  {saving
    ? (lang === "EN" ? "Saving..." : "جارٍ الحفظ...")
    : (lang === "EN" ? "Save" : "حفظ")}
</button>

    </div>
  </div>
</div>
          )}

          {/* ADMIN NOTE MODAL */}
{adminNoteOpen && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">

    <div className="w-full max-w-[640px] bg-white rounded-[14px] border border-[#e1e3e5] shadow-[0_20px_60px_rgba(0,0,0,0.25)] overflow-hidden">

      {/* HEADER */}
      <div className="flex items-center justify-between px-6 py-3 border-b border-[#e1e3e5] bg-[#f6f6f7]">
        <h3 className="text-[16px] font-semibold text-[#202223]">
          {lang === "EN" ? "Admin note" : "ملاحظة داخلية"}
        </h3>

        <button
          onClick={() => setAdminNoteOpen(false)}
          className="w-8 h-8 flex items-center justify-center rounded-md text-[#6d7175] hover:bg-[#f1f2f3]"
        >
          ✕
        </button>
      </div>

      {/* BODY */}
      <div className="px-6 py-4">

        <div className="relative">

          <textarea
            value={draftAdminNote}
            onChange={(e) => setDraftAdminNote(e.target.value)}
            maxLength={5000}
            className="w-full h-[60px] border border-[#c9cccf] rounded-[10px] px-4 py-2 text-[14px] text-[#202223] outline-none resize-none focus:border-[#008060]"
          />

          <div className="absolute bottom-2 right-3 text-[12px] text-[#6d7175]">
            {draftAdminNote.length}/5000
          </div>

        </div>

        <p className="text-[12px] text-[#8c9196] mt-1">
          {lang === "EN"
            ? "Internal note for staff only"
            : "ملاحظة داخلية للموظفين فقط"}
        </p>

      </div>

      {/* FOOTER */}
      <div className="flex justify-end gap-3 px-6 py-4 border-t border-[#e1e3e5]">

        <button
          onClick={() => setAdminNoteOpen(false)}
          className="h-[36px] px-4 rounded-[8px] border border-[#c9cccf] bg-white text-[14px] text-[#202223] font-medium hover:bg-[#f1f2f3]"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={saveAdminNote}
          className="h-[36px] px-4 rounded-[8px] text-[14px] font-semibold bg-[#202223] text-white hover:bg-black transition"
        >
          {lang === "EN" ? "Done" : "تم"}
        </button>

      </div>

    </div>

  </div>
)}

{showAddItem && (
<div className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-center justify-center p-4">

<div className="w-full max-w-[640px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl overflow-hidden">

{/* HEADER */}
<div className="bg-[#f6f6f7] px-6 py-4 border-b border-[#e1e3e5] flex items-center justify-between">

<h3 className="text-[18px] font-semibold text-[#202223]">
{TEXT.addItemTitle}
</h3>

<button
onClick={()=>{
setShowAddItem(false)
setActiveProduct(null)
setActiveVariant(null)
setVariantQty(1)
setEditMode(null)
setProductSearch("")
}}
className="w-8 h-8 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3]"
>
✕
</button>

</div>


<div className="p-5 max-h-[420px] overflow-y-auto">

{/* STEP 1 — PRODUCT SEARCH */}
{!activeProduct && (

<div className="space-y-3">

<div className="flex items-center gap-2">

<div className="flex-1 h-[42px] border border-[#8c9196] rounded-[12px] px-4 bg-white flex items-center gap-3">
<FaSearch className="text-[#6d7175] text-sm" />

<input
autoFocus
value={productSearch}
onChange={(e)=>setProductSearch(e.target.value)}
placeholder={TEXT.searchPlaceholder}
className="flex-1 outline-none text-sm text-[#202223]"
/>
</div>

</div>

<div className="border border-[#e1e3e5] rounded-[12px] overflow-hidden">

{products
.filter(p=>{
const q = productSearch.toLowerCase()

return (
p.public_id?.toLowerCase().includes(q) ||
p.name_en?.toLowerCase().includes(q) ||
p.name_ar?.toLowerCase().includes(q)
)
})
.slice(0,20)
.map(p=>{

const available =
p.variants?.reduce((s,v)=>s+v.stock_qty,0) || 0

const price = p.on_sale
? p.base_price*(1-p.sale_percent/100)
: p.base_price

return (

<button
key={p.id}
onClick={()=>setActiveProduct(p)}
className="w-full grid grid-cols-[1fr_100px_120px] items-center px-4 py-3 border-b border-[#f1f2f3] text-left hover:bg-[#f6f6f7]"
>

{/* PRODUCT */}
<div className="flex items-center gap-3">

<div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5]">
{p.image && (
<img src={p.image} alt="" className="w-full h-full object-cover"/>
)}
</div>

<div className="min-w-0">
<div className="text-sm font-semibold text-[#202223] truncate">
{lang==="EN"?p.name_en:p.name_ar}
</div>

<div className="text-xs text-[#6d7175]">
{p.public_id}
</div>
</div>

</div>

{/* STOCK */}
<div className="text-sm text-[#202223] text-center">
{available}
</div>

{/* PRICE */}
<div className="text-sm font-medium text-[#202223] text-right">
${Number(price).toFixed(2)}
</div>

</button>

)
})}

</div>

</div>
)}

{/* STEP 2 — VARIANT SELECT */}
{activeProduct && !activeVariant && (

<div className="space-y-3">

<button
onClick={()=>setActiveProduct(null)}
className="text-sm text-[#6d7175] hover:underline"
>
← {TEXT.back}
</button>

{activeProduct.variants
.filter(v=>v.stock_qty>0)
.map(v=>(

<button
key={v.id}
onClick={()=>setActiveVariant(v)}
className="w-full flex items-center justify-between border border-[#e1e3e5] rounded-[12px] px-4 py-3 hover:bg-[#f6f6f7]"
>

<span className="text-sm text-[#202223]">
{v.color_name} / {v.size}
</span>

<span className="text-xs text-[#6d7175]">
{TEXT.stock}: {v.stock_qty}
</span>

</button>

))}

</div>
)}

{/* STEP 3 — QUANTITY */}
{activeVariant && (

<div className="space-y-4">

<div className="text-sm font-medium text-[#202223] text-center">
{activeVariant.color_name} / {activeVariant.size}
</div>

<div className="flex items-center justify-center gap-4">

<button
onClick={()=>setVariantQty(q=>Math.max(1,q-1))}
className="w-10 h-10 rounded-full bg-[#f1f2f3]"
>
−
</button>

<span className="text-lg font-semibold">
{variantQty}
</span>

<button
onClick={()=>setVariantQty(q=>Math.min(activeVariant.stock_qty,q+1))}
className="w-10 h-10 rounded-full bg-[#f1f2f3]"
>
+
</button>

</div>

</div>
)}

</div>


{/* FOOTER */}
<div className="bg-[#f6f6f7] px-6 py-4 border-t border-[#e1e3e5] flex justify-end gap-3">

<button
onClick={()=>setShowAddItem(false)}
className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
>
{TEXT.cancel}
</button>

<button
onClick={async()=>{

const price = activeProduct.on_sale
? activeProduct.base_price*(1-activeProduct.sale_percent/100)
: activeProduct.base_price

await addAdminOrderItems(order.id,[{
product_id:activeProduct.id,
variant_id:activeVariant.id,
name_en:activeProduct.name_en,
name_ar:activeProduct.name_ar,
color:activeVariant.color_name,
size:activeVariant.size,
unit_price:price,
quantity:variantQty
}])

const fresh = await getAdminOrderById(order.id)
setOrder({...fresh,_originalStatus:fresh.status})

setShowAddItem(false)
setActiveProduct(null)
setActiveVariant(null)
setVariantQty(1)

}}
disabled={!activeVariant}
className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] disabled:opacity-50"
>
{TEXT.add}
</button>

</div>

</div>
</div>
)}
{itemToDelete && (
  <div className="fixed inset-0 bg-black/40 z-[9999] flex items-center justify-center">
    <div className="bg-white w-96 rounded-2xl p-6 shadow-xl animate-fadeSlide">
      <h3 className="text-lg font-bold text-red-600 mb-2">
  {TEXT.removeItemTitle}
</h3>

      <p className="text-sm text-gray-600 mb-6">
        {TEXT.removeItemConfirm}
        <b className="mx-1">{itemToDelete.title_en}</b>
        {lang==="EN"?"from this order?":"من هذا الطلب؟"}
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setItemToDelete(null)}
          className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={async () => {
            await deleteAdminOrderItem(order.id, itemToDelete.id);
            const fresh = await getAdminOrderById(order.id);
            setOrder({ ...fresh, _originalStatus: fresh.status });
            setItemToDelete(null);
            setEditMode(null);
          }}
          className="px-4 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700"
        >
          {lang === "EN" ? "Remove" : "حذف"}
        </button>
      </div>
    </div>
  </div>
)}
</div>

{discountModalOpen && (
<div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

  <div className="bg-white rounded-[18px] border border-[#e1e3e5] w-full max-w-[420px] overflow-hidden">

    <div className="px-6 py-3 border-b border-[#e1e3e5] bg-[#f6f6f7]">
      <h3 className="text-lg font-semibold text-[#202223]">
        {TEXT.discount}
      </h3>
    </div>

    <div className="p-5 space-y-4">

      {/* TYPE */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {lang === "EN" ? "Discount type" : "نوع الخصم"}
        </label>

        <select
          value={discountType}
          onChange={(e)=>setDiscountType(e.target.value)}
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
        >
          <option value="percent">
            {lang === "EN" ? "Percentage" : "نسبة مئوية"}
          </option>
          <option value="fixed">
            {lang === "EN" ? "Fixed amount" : "مبلغ ثابت"}
          </option>
        </select>
      </div>

      {/* AMOUNT */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {lang === "EN" ? "Amount" : "القيمة"}
        </label>

        <input
            type="number"
            min="0"
            step="0.01"
            value={draftDiscount}
            onChange={(e) => setDraftDiscount(Number(e.target.value))}
            className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
          />
      </div>

    </div>

    <div className="px-6 py-3 border-t border-[#e1e3e5] flex justify-between bg-[#f6f6f7]">

      {/* REMOVE */}
      <button
        onClick={() => {
              setDraftDiscount(0);
              setOrder((prev) => ({
                ...prev,
                discount: 0,
              }));
              setDiscountModalOpen(false);
            }}
        className="text-red-600 text-sm font-medium hover:underline"
      >
        {lang === "EN" ? "Remove" : "حذف"}
      </button>

      <div className="flex gap-3">

        <button
          onClick={()=>setDiscountModalOpen(false)}
          className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={() => {
            setOrder((prev) => {
            const subtotal = Number(prev.subtotal || 0);
            let value = Number(draftDiscount || 0);

            if (discountType === "percent") {
              value = subtotal * (value / 100);
            }

            return {
              ...prev,
              discount: value,
              discountType: discountType,
              discountInput: draftDiscount
            };
          });

            setDiscountModalOpen(false);
          }}
          className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black transition"
        >
          {TEXT.save}
        </button>

      </div>

    </div>

  </div>

</div>
)}

{extraFeesModalOpen && (
<div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

  <div className="bg-white rounded-[18px] border border-[#e1e3e5] w-full max-w-[420px] overflow-hidden">

    <div className="px-6 py-3 border-b border-[#e1e3e5] bg-[#f6f6f7]">
      <h3 className="text-lg font-semibold text-[#202223]">
        {TEXT.extraFees}
      </h3>
    </div>

    <div className="p-5 space-y-4">

      {/* LABEL */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {TEXT.extraFeesText}
        </label>

        <input
          type="text"
          value={draftExtraLabel}
          onChange={(e)=>setDraftExtraLabel(e.target.value)}
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
          placeholder={lang === "EN" ? "Example: Insurance" : "مثال: تأمين"}
        />
      </div>

      {/* AMOUNT */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {TEXT.extraFeesAmount}
        </label>

        <input
          type="number"
          min="0"
          step="0.01"
          value={draftExtraAmount}
          onChange={(e)=>setDraftExtraAmount(Number(e.target.value))}
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
        />
      </div>

    </div>

    <div className="px-6 py-3 border-t border-[#e1e3e5] flex justify-between bg-[#f6f6f7]">

      {/* DELETE */}
      <button
        onClick={()=>{
          setOrder(prev=>({
            ...prev,
            extraFeeLabel: "",
            extraFeeAmount: 0
          }));
          setExtraFeesModalOpen(false);
        }}
        className="text-red-600 text-sm font-medium hover:underline"
      >
        {lang === "EN" ? "Remove" : "حذف"}
      </button>

      <div className="flex gap-3">

        <button
          onClick={()=>setExtraFeesModalOpen(false)}
          className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={()=>{
            setOrder(prev=>({
              ...prev,
              extraFeeLabel: draftExtraLabel,
              extraFeeAmount: draftExtraAmount
            }));
            setExtraFeesModalOpen(false);
          }}
          className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black transition"
        >
          {TEXT.save}
        </button>

      </div>

    </div>

  </div>

</div>
)}

{showLeaveConfirm && (
  <div className="fixed inset-0 bg-black/40 z-[9999] flex items-center justify-center">
    <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl p-6">

      <h3 className="text-[18px] font-semibold text-[#202223] mb-2">
        {lang === "EN" ? "Save changes?" : "حفظ التغييرات؟"}
      </h3>

      <p className="text-sm text-[#6d7175] mb-6">
        {lang === "EN"
          ? "Do you want to save the changes before leaving this page?"
          : "هل تريد حفظ التغييرات قبل مغادرة الصفحة؟"}
      </p>

      <div className="flex justify-end gap-3">

        {/* DON'T SAVE */}
        <button
          onClick={() => navigate("/admin/orders")}
          className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px] text-[#202223] hover:bg-[#f1f2f3]"
        >
          {lang === "EN" ? "Don't Save" : "عدم الحفظ"}
        </button>

        {/* SAVE */}
        <button
          onClick={async () => {
              await updateOrderStatus();
            }}
          className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black"
        >
          {lang === "EN" ? "Save & Leave" : "حفظ ومغادرة"}
        </button>

      </div>

    </div>
  </div>
)}

        </main>
      </div>
    </div>
  );
}

export default AdminOrderDetails;